/**
 * The identity boundary an assistant surface's cached snapshot authority should be scoped by,
 * so a snapshot ref published under one identity is never silently reused after the session
 * transitions to another (e.g. an anonymous chat claimed by a member, or one member account
 * switching to another). Shared by every surface that needs this instead of each computing its
 * own -- see useAssistantSurface.ts's authorityScopeKey and TripPlannerChatProvider.tsx's
 * resolveTurnAuthority for its two current consumers.
 */
export function buildAssistantIdentityScopeKey(memberId: string | undefined): string {
  return memberId ? `member:${memberId}` : 'anonymous'
}
